import React from 'react';
import {
  FuelInteractiveIcon,
  FuelGridContainer,
  FuelGridItem,
  FuelTypography,
} from '@frete.com/fuel-react';
import { HeaderPropsInterface } from './HeaderTypes';

function Header({ onClose }: HeaderPropsInterface) {
  return (
    <FuelGridContainer gapRow={24} style={{ margin: 0 }}>
      <FuelGridItem md={6} lg={10} xlg={10}>
        <FuelTypography size="heading-md" weight="bold">
          A carga foi entregue?
        </FuelTypography>
        <FuelTypography size="body-sm" weight="medium" color="neutral-default">
          Confirme as entregas ou informe problemas. Após 7 dias da data de
          criação, o sistema confirmará automaticamente.
        </FuelTypography>
      </FuelGridItem>
      <FuelGridItem md={2} lg={2} xlg={2} style={{ textAlign: 'right' }}>
        <FuelInteractiveIcon icon="close" size="large" onClick={onClose} />
      </FuelGridItem>
    </FuelGridContainer>
  );
}

export default Header;
